import React from "react";
// ANT DESIGN COMPONENTS
import { Tooltip, Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faX } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

export default function FormularyHeaderActionsEdit({
  formIsValid,
  onClickSave,
  onClickResetForm,
}: {
  formIsValid: boolean;
  onClickSave: () => void;
  onClickResetForm: () => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__flexCenter">
      <div>
        <Tooltip title={t("general.save")}>
          <Button
            className={!formIsValid ? "buttonStyle__10" : ""}
            disabled={formIsValid}
            onClick={onClickSave}
            icon={<FontAwesomeIcon icon={faSave} />}
          />
        </Tooltip>
      </div>
      <div className="generalStyles__mlFix">
        <Tooltip title={t("general.cancel")}>
          <Button
            className="buttonStyle__14"
            onClick={onClickResetForm}
            icon={<FontAwesomeIcon icon={faX} />}
          />
        </Tooltip>
      </div>
    </div>
  );
}
